// @flow

import { call, fork, put, take } from 'redux-saga/effects'
import { GET_ORDERS_STATUSES, getOrdersStatuses } from 'src/redux/actions/orders/orders'
import http from 'src/services/http'

// types
import type { IOEffect } from 'redux-saga/effects'

function * watchGetOrdersStatuses(): Generator<IOEffect, void, any> {
  while (true) {
    yield take(GET_ORDERS_STATUSES.REQUEST)

    try {
      const data = yield call(http, 'admin/payment/statuses', {
        method: 'GET',
      })

      yield put(getOrdersStatuses.success(data.data))
    } catch (e) {
      yield put(getOrdersStatuses.error(e.message))
    }
  }
}

export default [fork(watchGetOrdersStatuses)]
